// Sdílený in-memory cache pro Log Expired YYYY data.
// Použivají ho LogExpired.jsx + ClientDetail.jsx.
//
// Cíl: instantní render po prvním fetchi. Klient detail open = filter z paměti (0ms).
// Plus prewarm — Clients.jsx parent volá prewarmLogExpiredCache() na mount,
// takže cache je zahřátá ještě než user klikne na klienta nebo navigaci na /clients/log-expired.
//
// Cache TTL: 60s. Po toggle Schváleno se invaliduje (invalidateLogExpiredCache).

import { apiFetch } from "./api.js";

const TTL_MS = 60_000;
const _cache = new Map(); // key: "year" nebo "year-month", value: { entries, loadedAt }

function makeKey(year, month) {
  return month ? `${year}-${month}` : `${year}`;
}

// Hlavní fetch — vrací entries (volitelně filtrované podle clientName na frontendu).
// Cache hit (TTL 60s) = instantní z paměti, bez HTTP fetchu.
export async function fetchLogExpired({ year, month, clientName, forceRefresh } = {}) {
  if (!year) year = new Date().getFullYear();
  const key = makeKey(year, month);
  const now = Date.now();

  const cached = _cache.get(key);
  if (!forceRefresh && cached && now - cached.loadedAt < TTL_MS) {
    return filterByClient(cached.entries, clientName);
  }

  // Fetch from backend
  let url = `/api/log-expired?year=${year}`;
  if (month) url += `&month=${month}`;
  const r = await apiFetch(url);
  const j = await r.json();
  if (j.error) throw new Error(j.error);
  const entries = j.entries || [];
  _cache.set(key, { entries, loadedAt: now });
  return filterByClient(entries, clientName);
}

function filterByClient(entries, clientName) {
  if (!clientName) return entries;
  const lower = String(clientName).toLowerCase();
  return entries.filter((e) => e.jmeno && e.jmeno.toLowerCase().includes(lower));
}

// Prewarm — pre-fetch v pozadí. Použije Clients.jsx na mount.
// Best-effort: pokud selže, ignorujeme (uživatel pak dostane fetch při kliknutí).
export function prewarmLogExpiredCache(year) {
  fetchLogExpired({ year }).catch(() => {});
}

// Invalidace cache po edit (toggle / bulk / create / delete).
// Volá se z LogExpired.jsx aby další openClientDetail viděl fresh data.
export function invalidateLogExpiredCache(year) {
  if (year) {
    // Invaliduj pouze daný rok (a všechny year-month kombinace v rámci roku)
    for (const key of _cache.keys()) {
      if (key === String(year) || key.startsWith(`${year}-`)) {
        _cache.delete(key);
      }
    }
  } else {
    _cache.clear();
  }
}
